import { render, staticRenderFns } from "./MainNavbar.vue?vue&type=template&id=4473e1c5&scoped=true&"
import script from "./MainNavbar.vue?vue&type=script&lang=js&"
export * from "./MainNavbar.vue?vue&type=script&lang=js&"
import style0 from "./MainNavbar.vue?vue&type=style&index=0&id=4473e1c5&scoped=true&lang=css&"
import style1 from "./MainNavbar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4473e1c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4473e1c5')) {
      api.createRecord('4473e1c5', component.options)
    } else {
      api.reload('4473e1c5', component.options)
    }
    module.hot.accept("./MainNavbar.vue?vue&type=template&id=4473e1c5&scoped=true&", function () {
      api.rerender('4473e1c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/MainNavbar.vue"
export default component.exports